import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/features/rbac/components/require-permission'
import { StaffDetailPage } from '@/features/users/staff'

function StaffRoute() {
  const { userId } = Route.useParams()
  return (
    <RequirePermission permission='user.view'>
      <StaffDetailPage userId={userId} />
    </RequirePermission>
  )
}

export const Route = createFileRoute('/_authenticated/staff/$userId')({
  component: StaffRoute,
})
